/**
 * FormValidation (https://formvalidation.io)
 * The best validation library for JavaScript
 * (c) 2013 - 2018 Nguyen Huu Phuoc <me@phuoc.ng>
 */

enum Status {
    Ignored = 'Ignored',
    Invalid = 'Invalid',
    NotValidated = 'NotValidated',
    Valid = 'Valid',
    Validating = 'Validating',
}

export default Status;
